module.exports = __webpack_public_path__ + "img/logojpg.80f3ac01.jpg";